(function () {
  window.__abMainStarted = true;

  try {

    const AB_STUDIO_API_DOMAIN = 'https://api-custom.medzt.com';

    // ── Config ────────────────────────────────────────────────────────────────
    var FETCH_TIMEOUT_MS = 1500;
    var PUBLISH_RETRY_INTERVAL_MS = 50;
    var PUBLISH_RETRY_MAX_ATTEMPTS = 8; // tổng tối đa 400ms

    var PAGE_EXPERIMENT_TYPES = {
      'homepage': ['content'],
      'product': ['content'],
      'collection': ['content'],
      'custom_page': ['content'],
    };

    // ── Page context — inject từ Shopify Liquid ───────────────────────────────
    var country = window.ShopifyVars.context.country || null;
    var template_suffix = window.ShopifyVars.context.template_suffix || null;
    var currentView = new URLSearchParams(window.location.search).get('view');
    var ref = document.referrer && new URL(document.referrer).hostname;
    var referring_domain = (ref && ref !== window.location.hostname) ? ref : null;

    // ── Split URL redirect params — đọc thẳng từ URL, đơn giản, dễ debug ──────
    var urlParams = new URLSearchParams(window.location.search);
    var urlControlPath = urlParams.get('ab_control');
    var urlExperimentId = urlParams.get('ab_exp');
    var urlVariantId = urlParams.get('ab_variant');
    var hasAbControl = !!urlControlPath;

    // ── Visitor/session identity ──────────────────────────────────────────────
    function getOrCreateId(storage, key) {
      try {
        var id = storage.getItem(key);
        if (!id) {
          id = crypto.randomUUID();
          storage.setItem(key, id);
        }
        return id;
      } catch (e) {
        console.warn('[ABStudio] Storage lỗi/bị chặn cho key ' + key + ':', e);
        return null;
      }
    }

    var visitor_id = getOrCreateId(localStorage, 'ab_visitor_id');
    var session_id = getOrCreateId(sessionStorage, 'ab_session_id');

    // ── Helpers ───────────────────────────────────────────────────────────────
    function getDeviceType() {
      var ua = navigator.userAgent.toLowerCase();
      if (/tablet|ipad|playbook|silk/.test(ua)) return 'tablet';
      if (/mobile|iphone|ipod|android|blackberry|mini|windows\sce|palm/.test(ua)) return 'mobile';
      return 'desktop';
    }

    function getPageUrl() {
      var path = window.location.pathname.replace(/\/+$/, '');
      return path === '' ? '/' : path;
    }

    function getPageUrlFromUrl(url) {
      var path = url.pathname.replace(/\/+$/, '');
      return path === '' ? '/' : path;
    }

    function getContentExperimentCacheKey(targetPageUrl, targetCountry) {
      var resolvedPageUrl = targetPageUrl || pageUrl;
      var resolvedCountry = targetCountry || country || 'unknown';
      return resolvedCountry + '::' + resolvedPageUrl;
    }

    function getUTMParam(key) {
      var p = new URLSearchParams(window.location.search);
      var value = p.get(key);
      if (value) {
        localStorage.setItem(key, value);
        return value;
      }
      return localStorage.getItem(key) || null;
    }

    function getPageCategory(pageUrl) {
      if (pageUrl === '/') return 'homepage';
      if (pageUrl.startsWith('/products')) return 'product';
      if (pageUrl.startsWith('/collections')) return 'collection';
      if (pageUrl.startsWith('/pages')) return 'custom_page';
      return null;
    }

    // Tính 1 lần, dùng lại cho cả fetchExperiment + getPageCategory
    var pageUrl = getPageUrl();
    var deviceType = getDeviceType();
    var utmParams = {
      utm_source: getUTMParam('utm_source'),
      utm_medium: getUTMParam('utm_medium'),
      utm_campaign: getUTMParam('utm_campaign'),
      utm_content: getUTMParam('utm_content'),
      utm_term: getUTMParam('utm_term'),
    };

    // ── Canonical tag (Split URL) — chạy độc lập, không phụ thuộc fetch ────────
    (function injectCanonicalTagIfNeeded() {
      if (!urlControlPath) return;

      var existing = document.querySelector('link[rel="canonical"]');
      if (existing) existing.remove();

      var link = document.createElement('link');
      link.rel = 'canonical';
      link.href = window.location.origin + urlControlPath;
      document.head.appendChild(link);
    })();

    // ── Build experiment data ─────────────────────────────────────────────────
    // experiment = null khi không có test nào chạy — experiment_id/variant_id
    // trả về null, các field visitor/session/UTM vẫn đầy đủ như bình thường.
    function buildExperimentData(experiment) {
      return {
        experiment_id: experiment ? experiment.experiment_id : null,
        variant_id: experiment ? experiment.variant_id : null,
        visitor_id: visitor_id,
        session_id: session_id,
        country: country,
        referring_domain: referring_domain,
        fbclid: getUTMParam('fbclid'),
        gclid: getUTMParam('gclid'),
        ttclid: getUTMParam('ttclid'),
        cjevent: getUTMParam('cjevent'),
        epik: getUTMParam('epik'),
        utm_source: utmParams.utm_source,
        utm_medium: utmParams.utm_medium,
        utm_campaign: utmParams.utm_campaign,
        utm_content: utmParams.utm_content,
        utm_term: utmParams.utm_term,
      };
    }

    // ══════════════════════════════════════════════════════════════════════════
    // Resolve action theo loại experiment trong 'content' — ĐÂY LÀ NƠI DUY NHẤT
    // cần sửa/thêm khi Duplicate Template hay Split URL đổi cách trả dữ liệu.
    // ══════════════════════════════════════════════════════════════════════════

    function resolveTemplateAction(suffix, baseUrl, refCurrentView) {
      if (suffix === '' || refCurrentView === suffix) return { type: 'stay' };
      if (!suffix) return null; // thiếu dữ liệu, coi như không xác định được
      var url = new URL(baseUrl);
      url.searchParams.set('view', suffix);
      return { type: 'redirect', url: url.toString() };
    }

    function resolveSplitUrlAction(variantPath, passUrlParams, refPageUrl, sourceQueryString, experimentId, variantId) {
      if (!variantPath || variantPath === refPageUrl) return { type: 'stay' };
      var target = new URL(window.location.origin + variantPath);
      if (passUrlParams) {
        new URLSearchParams(sourceQueryString).forEach(function (value, key) {
          target.searchParams.set(key, value);
        });
      }
      target.searchParams.set('ab_control', refPageUrl);
      if (experimentId) target.searchParams.set('ab_exp', experimentId);
      if (variantId) target.searchParams.set('ab_variant', variantId);
      return { type: 'redirect', url: target.toString() };
    }

    // opts: { refPageUrl, refCurrentView, baseUrlForRedirect, sourceQueryString, experimentId, variantId }
    function resolveActionForVariant(variantData, opts) {
      if (!variantData) return null;
      if (typeof variantData.path === 'string') {
        return resolveSplitUrlAction(variantData.path, variantData.pass_url_params, opts.refPageUrl, opts.sourceQueryString, opts.experimentId, opts.variantId);
      }
      if (typeof variantData.template_suffix === 'string') {
        return resolveTemplateAction(variantData.template_suffix, opts.baseUrlForRedirect, opts.refCurrentView);
      }
      return null;
    }

    function commitVariantAction(action, data) {
      if (action.type === 'redirect') {
        window.location.replace(action.url);   // redirect ngay, không publish
        return;
      }
      publishExperiment(data);
      revealPage();
    }

    // ── Anti-flicker ──────────────────────────────────────────────────────────
    function getCachedContentExperiment(targetPageUrl) {
      try {
        var cacheKey = getContentExperimentCacheKey(targetPageUrl);
        var cache = JSON.parse(sessionStorage.getItem('ab_content_experiment_cache') || '{}');
        return cache[cacheKey] || null;
      } catch (e) {
        console.warn('[ABStudio] Failed to read experiment cache:', e);
      }

      return null;
    }

    function setCachedContentExperiment(data, targetPageUrl) {
      try {
        var cacheKey = getContentExperimentCacheKey(targetPageUrl, data && data.country);
        var cache = JSON.parse(sessionStorage.getItem('ab_content_experiment_cache') || '{}');
        cache[cacheKey] = data;
        sessionStorage.setItem('ab_content_experiment_cache', JSON.stringify(cache));
      } catch (e) {
        console.warn('[ABStudio] Failed to write experiment cache:', e);
      }
    }

    // Build cache object từ data + action đã resolve — dùng chung mọi nơi
    function buildCacheData(data, action, targetPageUrl) {
      return Object.assign({}, data,
        action.type === 'redirect' ? { action: 'redirect', url: action.url } : { action: 'stay' },
        { page_url: targetPageUrl }
      );
    }

    // Nếu cached redirect trỏ tới cùng path (chỉ khác ?view=) → trả về suffix đó.
    // Nếu trỏ sang path khác hẳn (vd Split URL) → trả null, không áp dụng được
    // cho việc rewrite href của link (chỉ hữu ích cho hover-prefetch).
    function getSamePathViewParam(redirectUrl, targetPageUrl) {
      try {
        var u = new URL(redirectUrl, window.location.origin);
        var uPath = u.pathname.replace(/\/+$/, '') || '/';
        if (uPath !== targetPageUrl) return null;
        return u.searchParams.get('view');
      } catch (e) {
        return null;
      }
    }

    function revealPage() {
      console.log("revealPage", Date.now())
      document.documentElement.classList.remove('ab-prehide');
      var loader = document.getElementById('ab-loader');
      var style = document.getElementById('ab-prehide-style');
      if (loader) loader.remove();
      if (style) style.remove();
      if (window.__abPrehideTimer) {
        clearTimeout(window.__abPrehideTimer);
        window.__abPrehideTimer = null;
      }
    }


    // ── Fetch experiment theo type ────────────────────────────────────────────
    function fetchExperiment(type, targetPageUrl) {
      return fetch(AB_STUDIO_API_DOMAIN + '/active-experiment', {
        method: 'POST',
        signal: AbortSignal.timeout(FETCH_TIMEOUT_MS),
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: [
            'query GetActiveExperiment($input: GetActiveExperimentInput!) {',
            '  getActiveExperiment(input: $input) {',
            '    experiment_id',
            '    variant_id',
            '    experiment_type',
            '    variant_data',
            '  }',
            '}'
          ].join('\n'),
          variables: {
            input: {
              page_url: targetPageUrl || pageUrl,
              visitor_id: visitor_id,
              device_type: deviceType,
              experiment_type: type,
              template_suffix: template_suffix,
              utm_source: utmParams.utm_source,
              utm_medium: utmParams.utm_medium,
              utm_campaign: utmParams.utm_campaign,
              utm_content: utmParams.utm_content,
              country: country,
              referring_domain: referring_domain,
            }
          }
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('API error: ' + res.status);
          return res.json();
        })
        .catch(function (err) {
          console.warn('[ABStudio] fetchExperiment(' + type + ') failed:', err);
          return null;
        });
    }

    // ── Publish sự kiện cho Pixel — hàm chung, dùng lại cho mọi loại event ─────
    var hasPublishedTrackingEvent = false;

    function publish(eventName, data) {
      function tryPublish() {
        if (!(window.Shopify && window.Shopify.analytics)) return false;
        try {
          Shopify.analytics.publish(eventName, data);
          return true;
        } catch (err) {
          console.warn('[ABStudio] Failed to publish ' + eventName + ' event:', err);
          return false;
        }
      }

      if (tryPublish()) return Promise.resolve(true);

      return new Promise(function (resolve) {
        var attempts = 0;
        var retryInterval = setInterval(function () {
          attempts++;
          if (tryPublish()) {
            clearInterval(retryInterval);
            resolve(true);
          } else if (attempts >= PUBLISH_RETRY_MAX_ATTEMPTS) {
            console.warn('[ABStudio] Shopify.analytics not available after retries, giving up.');
            clearInterval(retryInterval);
            resolve(false);
          }
        }, PUBLISH_RETRY_INTERVAL_MS);
      });
    }

    function publishExperiment(data) {
      hasPublishedTrackingEvent = true;
      return publish('abstudio:experiment_assigned', data);
    }

    function publishNoActiveExperiment() {
      if (hasPublishedTrackingEvent) return;
      try {
        publishExperiment(buildExperimentData(null));
      } catch (e) {
        console.warn('[ABStudio] publishNoActiveExperiment failed:', e);
      }
    }

    // ── Experiment type handlers ──────────────────────────────────────────────
    function handleContentExperiment(experiment, isVersionBResolved) {
      if (isVersionBResolved) {
        // Case ?view= (Duplicate Template): landing page CÙNG path với trang
        // gốc → đọc được cache (cùng cache key), publish lại đầy đủ
        // experiment_id/variant_id thật.
        //
        // Case Split URL (landing ở B, path khác A): B KHÔNG đọc được cache
        // của A (khác cache key) — dùng ab_exp/ab_variant trong URL (A gắn vào
        // lúc redirect) để publish đủ experiment_id/variant_id thật.
        var cached = getCachedContentExperiment();
        if (cached && cached.session_id) {
          publishExperiment(cached);
        } else {
          publishExperiment(buildExperimentData(
            urlExperimentId ? { experiment_id: urlExperimentId, variant_id: urlVariantId } : null
          ));
        }
        revealPage();
        return;
      }

      if (!experiment) {
        revealPage();
        return;
      }

      var action = resolveActionForVariant(experiment.variant_data, {
        refPageUrl: pageUrl,
        refCurrentView: currentView,
        baseUrlForRedirect: window.location.href,
        sourceQueryString: window.location.search,
        experimentId: experiment.experiment_id,
        variantId: experiment.variant_id
      });

      if (!action) {
        console.warn('[ABStudio] Cannot resolve action for variant_data:', experiment);
        revealPage();
        return;
      }

      var data = buildExperimentData(experiment);
      setCachedContentExperiment(buildCacheData(data, action, pageUrl));
      commitVariantAction(action, data);
    }

    var EXPERIMENT_TYPE_HANDLERS = {
      'content': handleContentExperiment,
    };

    var EXPERIMENT_IS_VERSION_B = {
      'content': function () {
        // currentView !== null: đã redirect ?view= rồi (Duplicate Template)
        // hasAbControl: đang là variant (B) landing từ Split URL —
        // assignment/tracking đã xử lý ở trang control (A) trước khi redirect.
        return currentView !== null || hasAbControl;
      },
    };

    function getEligibleContentLink(link) {
      if (!link || !link.href || link.target || link.hasAttribute('download')) return null;

      var url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.searchParams.has('view')) return null;

      var targetPageUrl = getPageUrlFromUrl(url);
      if (targetPageUrl === pageUrl) return null;
      if ((PAGE_EXPERIMENT_TYPES[getPageCategory(targetPageUrl)] || []).indexOf('content') === -1) return null;

      return {
        url: url,
        page_url: targetPageUrl
      };
    }

    function applyCachedViewToLink(link) {
      var target = getEligibleContentLink(link);
      if (!target) return false;

      var cachedData = getCachedContentExperiment(target.page_url);
      if (!cachedData) return false;
      if (cachedData.action !== 'redirect') return true; // stay → không cần sửa link

      var viewSuffix = getSamePathViewParam(cachedData.url, target.page_url);
      if (!viewSuffix) return true; // redirect sang path khác (vd Split URL) → bỏ qua

      target.url.searchParams.set('view', viewSuffix);
      link.href = target.url.toString();
      return true;
    }

    // Bắt MỌI click trên trang ở giai đoạn capture (chạy sớm, trước khi click
    // thật sự điều hướng) — nếu click đúng/trong 1 thẻ <a>, tranh thủ sửa href
    // của nó theo cache đã biết (nếu có), tránh phải redirect thêm 1 lần nữa
    // sau khi đã vào trang đích. Không có cache thì bỏ qua, không ảnh hưởng gì.
    function getLinkFromEvent(event) {
      return event.target && event.target.closest && event.target.closest('a[href]');
    }

    document.addEventListener('click', function (event) {
      applyCachedViewToLink(getLinkFromEvent(event));
    }, true);

    // ── Main flow ─────────────────────────────────────────────────────────────

    var pageCategory = getPageCategory(pageUrl);
    var experimentTypes = PAGE_EXPERIMENT_TYPES[pageCategory] || [];

    if (experimentTypes.length === 0) {
      console.log('[ABStudio] No experiment types for page category: ' + pageCategory);
      publishNoActiveExperiment();
      revealPage();
      return;
    }

    if (currentView === null && !hasAbControl && experimentTypes.indexOf('content') !== -1) {
      var cachedContentExperiment = getCachedContentExperiment();

      // Cache thiếu session_id (vd cache cũ từ lần chạy trước, hỏng dữ liệu) →
      // coi như cache miss, không dùng, để rơi xuống fetch mới bên dưới thay vì
      // replay data cũ/sai mãi mãi.
      if (cachedContentExperiment && cachedContentExperiment.action && cachedContentExperiment.session_id) {
        commitVariantAction(
          { type: cachedContentExperiment.action, url: cachedContentExperiment.url },
          cachedContentExperiment
        );
        return;
      }
    }

    Promise.all(experimentTypes.map(function (type) {
      var checkVersionB = EXPERIMENT_IS_VERSION_B[type];
      if (checkVersionB && checkVersionB()) return Promise.resolve({ isVersionBResolved: true });
      return fetchExperiment(type);
    }))
      .then(function (results) {
        results.forEach(function (data, i) {
          var type = experimentTypes[i];
          var isVersionBResolved = data?.isVersionBResolved === true;
          var experiment = isVersionBResolved ? null : data?.data?.getActiveExperiment;

          if (!isVersionBResolved && !experiment) {
            console.log('[ABStudio] No active experiment for type: ' + type);
            publishNoActiveExperiment();
            revealPage();
            return;
          }

          var handler = EXPERIMENT_TYPE_HANDLERS[type];
          if (!handler) return;

          handler(experiment, isVersionBResolved);
        });
      })
      .catch(function (err) {
        console.warn('[ABStudio] Main flow failed:', err);
        publishNoActiveExperiment();
        revealPage();
      });

  } catch (err) {
    // Fail-safe cuối cùng: BẤT KỲ lỗi đồng bộ nào xảy ra ở trên (vd
    // window.ShopifyVars undefined, URL malformed...) đều rơi vào đây.
    // Không dùng revealPage() vì lỗi có thể xảy ra TRƯỚC khi hàm đó được định nghĩa
    console.warn('[ABStudio] Unexpected error, revealing page as fail-safe:', err);
    document.documentElement.classList.remove('ab-prehide');
    var failsafeLoader = document.getElementById('ab-loader');
    var failsafeStyle = document.getElementById('ab-prehide-style');
    if (failsafeLoader) failsafeLoader.remove();
    if (failsafeStyle) failsafeStyle.remove();
    if (window.__abPrehideTimer) {
      clearTimeout(window.__abPrehideTimer);
      window.__abPrehideTimer = null;
    }
  }
})();